<template>
    <div class="cicrcle_chart">
        <svg class="circle-chart chart1" viewbox="0 0 33.83098862 33.83098862" width="50" height="50" xmlns="http://www.w3.org/2000/svg">
            <circle class="circle-chart__background circle_svg" stroke="none" stroke-width="1.5" fill="none" cx="50%" cy="50%" r="15.91549431" />
            <circle :style="{stroke: colors.theme == 'dark' ? '#7c848b':'#cccccc'}" class="circle-chart__circle circle_svg" stroke="" stroke-width="1.5" 
            stroke-dasharray="58,100"
            stroke-linecap="none" fill="none" cx="50%" cy="50%" r="15.91549431" />
        </svg>
            <span class="chart_center_value" :style="{color: `${colors.secondary}`}"
            :class="{'three_chars': reportData.performance.percentageHit*100 > 99}"
            >{{reportData.performance.percentageHit*100}}<small>%</small></span>
        <svg class="circle-chart chart2" viewbox="0 0 33.83098862 33.83098862" width="40" height="40" xmlns="http://www.w3.org/2000/svg">
            <circle class="circle-chart__background circle_svg" :style="{stroke: colors.theme == 'dark' ? '#000':'#f0f0f0'}" stroke="none" stroke-width="1.5" fill="transparent" cx="50%" cy="50%" r="15.91549431" />
            <circle :style="{stroke: `${colors.secondary}`}" class="circle-chart__circle circle_svg" stroke="" stroke-width="1.5"
            :stroke-dasharray="`${reportData.performance.percentageHit*100},100`" 
            stroke-linecap="none" fill="none" cx="50%" cy="50%" r="15.91549431" />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'circle-chart',
    props:[],
    data: () => ({
        reportData: JSON.parse(localStorage.getItem('report')),
        colors: {}
    }),

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        // console.log(this.reportData.performance.percentageHit*100)
    }
}
</script>
<style lang="scss" scoped>
.circle_chart{
    display: flex;
    align-items: center;

}
.circle-chart{
    transform: scale(5) rotate(-90deg);
}
.chart1{
    position: relative;
    left: 25%;

    circle:last-child{
        // stroke: rgba($color: #2F353A, $alpha: .3);
    }

}
.chart2{
    position: relative;
    right: 25%;
    bottom: 5px;
    transform: scale(4.2) rotate(-90deg);
    
    circle:last-child{
        // stroke: rgba($color: #83037D, $alpha: 1.0);
    }
}
.chart_center_value.three_chars{
    font-size: 55px;
    margin: -2px -50px;

    small{
        font-size: 26px;
        right: 3px;
    }
}
.chart_center_value{
    position: absolute;
    z-index: 9;
    margin: -10px -40px;
    // color: rgba($color: #83037D, $alpha: 1.0);
    font-weight: 700;
    font-size: 62px;

    small{
        font-size: 23px;    
        position: relative;
        bottom: 20px;
        right: 0px;
    }

}

@media only screen and (max-width: 430px){
    .chart_center_value.three_chars{
        font-size: 42px;
        margin: 5px -40px;


        small{
            font-size: 21px;
        }
    }
    .circle-chart{
        transform: scale(4) rotate(-90deg);
    }
    .chart2{
        transform: scale(3.7) rotate(-90deg);
    }
    .chart_center_value{
        margin: 2px -32px;
        font-size: 51px;
        
        small{
            font-size: 22px;
        }
    }
}

@media only screen and (max-width: 360px){
    .chart_center_value.three_chars{
        font-size: 31px;
        margin: 13px -29px;

        small{
            font-size: 16px;
            top: -11px;
            right: -1px;
        }
    }    
    .circle-chart{
        transform: scale(3.3) rotate(-90deg);
    }
    .chart2{
        transform: scale(3) rotate(-90deg);
    }
    .chart_center_value{
        margin: 8px -22px;
        font-size: 35px;

        small{
            font-size: 18px;
            bottom: 13px;
            right: -1px;
        }
    }
}
@media only screen and (max-width: 333px){
    .chart_center_value.three_chars{
        font-size: 31px;
        margin: 31px -45px;
    }  
    .circle-chart{
        transform: scale(3) rotate(-90deg);
    }
    .chart1{
        left: 10px;
        top: 22px;

    }
    .chart2{
        transform: scale(2.7) rotate(-90deg);
        left: 15px;
        bottom: 27px;
    }
    .chart_center_value{
        margin: 29px -32px;

        small{
            font-size: 12px;
            bottom: 17px;
            right: 0px;
        }
    }
}
</style>
